import { useState, useCallback } from 'react';

const DEFAULT_PRINT_CONFIG = {
  includeAcPayee: false,
  includeBeneficiary: true,
  includeDate: true,
  includeAmount: true,
  includeAmountPrefix: false,
  includeAmountSuffix: false,
  includeNonNegotiable: false,
  includeBeneficiary2: false,
  includeRemarks: false,
  chequeSizedPdf: false,
  excludeCurrencyWords: false,
};

export const usePrintConfiguration = (initialConfig = DEFAULT_PRINT_CONFIG) => {
  const [printConfig, setPrintConfig] = useState({
    ...DEFAULT_PRINT_CONFIG,
    ...initialConfig
  });

  const updatePrintConfig = useCallback((newConfig) => {
    setPrintConfig(prev => ({
      ...prev,
      ...newConfig
    }));
  }, []);

  const resetPrintConfig = useCallback(() => {
    setPrintConfig(DEFAULT_PRINT_CONFIG);
  }, []);

  const togglePrintOption = useCallback((option) => {
    setPrintConfig(prev => ({
      ...prev,
      [option]: !prev[option]
    }));
  }, []);

  const enableAllOptions = useCallback(() => {
    setPrintConfig({
      includeAcPayee: true,
      includeBeneficiary: true,
      includeDate: true,
      includeAmount: true,
      includeAmountPrefix: true,
      includeAmountSuffix: true,
      includeNonNegotiable: true,
      includeBeneficiary2: true,
      includeRemarks: true,
      chequeSizedPdf: true,
      excludeCurrencyWords: false,
    });
  }, []);

  const disableAllOptions = useCallback(() => {
    setPrintConfig({
      includeAcPayee: false,
      includeBeneficiary: false,
      includeDate: false,
      includeAmount: false,
      includeAmountPrefix: false,
      includeAmountSuffix: false,
      includeNonNegotiable: false,
      includeBeneficiary2: false,
      includeRemarks: false,
      chequeSizedPdf: false,
      excludeCurrencyWords: false,
    });
  }, []);

  return {
    printConfig,
    updatePrintConfig,
    resetPrintConfig,
    togglePrintOption,
    enableAllOptions,
    disableAllOptions,
  };
};

export default usePrintConfiguration; 